import React from 'react';

const AssignModal = ({ selectedRequest, technicians, selectedTechnician, setSelectedTechnician, handleAssignTechnician, setShowAssignModal, setSelectedRequest, getMockTechnicians, setTechnicians, showToast }) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg p-6 w-full max-w-md">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        Assign Technician to: {selectedRequest.title}
      </h3>

      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <label className="block text-sm font-medium text-gray-700">
            Select Technician
          </label>
          <button
            type="button"
            onClick={() => {
              console.log('Manually reloading technicians...');
              setTechnicians(getMockTechnicians());
              showToast('Technicians reloaded', 'info');
            }}
            className="text-xs text-blue-600 hover:text-blue-800"
          >
            Reload Technicians
          </button>
        </div>

        {technicians.length === 0 ? (
          <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
            <p className="text-sm text-yellow-800 mb-2">No technicians available.</p>
            <button
              type="button"
              onClick={() => {
                setTechnicians(getMockTechnicians());
                showToast('Mock technicians loaded', 'info');
              }}
              className="text-xs bg-yellow-600 text-white px-2 py-1 rounded hover:bg-yellow-700"
            >
              Load Sample Technicians
            </button>
          </div>
        ) : (
          <select
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            value={selectedTechnician}
            onChange={(e) => setSelectedTechnician(e.target.value)}
          >
            <option value="">Choose a technician...</option>
            {technicians
              .filter(tech => tech.availability === 'Available')
              .map(tech => (
                <option key={tech.id} value={tech.id}>
                  {tech.name} - {tech.specialization} ({tech.currentAssignments} current assignments)
                </option>
              ))}
          </select>
        )}
      </div>

      <div className="flex gap-3">
        <button
          onClick={handleAssignTechnician}
          disabled={!selectedTechnician}
          className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
        >
          Assign
        </button>
        <button
          onClick={() => {
            setShowAssignModal(false);
            setSelectedRequest(null);
            setSelectedTechnician('');
          }}
          className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
);

export default AssignModal;
